<template>
    <router-view></router-view>
    <!-- <tab-bar></tab-bar> -->
</template>

<script>
// import TabBar from "@/components/TabBar.vue";
import functions from '@/functions.js';
import client from '@/configs/client.js';

export default {
    // components: { TabBar },
    name: "App",
    created() {
        // 初始化微信分享配置
        if (client.wechat) {
            this.$http.get('wechat/share', {params: {url: location.href}}).then(result => {
                window.wx.config({
                    appId: result.data.config.appId,
                    timestamp: result.data.config.timestamp,
                    nonceStr: result.data.config.nonceStr,
                    signature: result.data.config.signature,
                    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
                })
            })
            /* eslint-disable */
            if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
                this.handleFontSize();
            } else if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.handleFontSize, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.handleFontSize);
                document.attachEvent('onWeixinJSBridgeReady', this.handleFontSize);
            }
            /* eslint-enable */
        }
        // 静默登录
        if (client.xinhua) {
            let uuid = this.$cookie.get('xhw_auth_sign');
            if (uuid) {
                if (this.$store.state.authorizationTime < new Date().getTime()) {
                    this.$http.post('auth', {uuid: uuid}).then(result => {
                        this.$store.commit('setUser', result.data.user);
                        this.$store.commit('setAuthorization', result.data.token);
                        location.reload();
                    });
                }
            } else {
                this.$store.commit('setAuthorization', null);
            }
        }
    },
    mounted() {
        let spread = functions.getQuery('spread');
        if (spread) {
            this.$store.commit('setSpread', spread);
        }
        let referrer = functions.getQuery('referrer');
        if (referrer) {
            this.$store.commit('setReferrerUid', referrer);
        }
    },
    methods: {
        handleFontSize() {
            /* eslint-disable */
            WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0});
            WeixinJSBridge.on('menu:setfont', () => {
                WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0});
            })
            /* eslint-enable */
        }
    }
};
</script>

<style lang="scss">
#app {
    min-height: 100%;
    margin: 0 auto;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
}
</style>
